import {charcoal} from '../sass/base/_exports.sass';

export const AreaIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox="0 0 31 30"
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 6.25V23.75C4.25 25.1287 5.37125 26.25 6.75 26.25H24.25C25.6287 26.25 26.75 25.1287 26.75 23.75V6.25C26.75 4.87125 25.6287 3.75 24.25 3.75H6.75C5.37125 3.75 4.25 4.87125 4.25 6.25ZM24.2525 23.75H6.75V6.25H24.25L24.2525 23.75Z"
        fill={color}
      />
      <path
        d="M19.25 15H21.75V8.75H15.5V11.25H19.25V15ZM15.5 18.75H11.75V15H9.25V21.25H15.5V18.75Z"
        fill={color}
      />
    </svg>
  );
};
